<ion-app>
    <menu [cu]="cu | async"></menu>
    <ion-router-outlet main id="menu-content"></ion-router-outlet>
</ion-app>
